import loggingService from '../services/util/loggingService'

var serviceName = 'countyService'
var path = '/Lookup/County/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'ListLookup')

    return http.get(path + 'ListLookup')
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/countyService.js